import {Component, Input, ViewEncapsulation} from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  templateUrl: './layout.component.html',
  imports: [
    RouterOutlet
  ],
  styleUrls: ['./layout.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent {

  @Input() imagePath? = ""
  @Input() header = ""
  @Input() description? = ""
  @Input() body? = ""
}
